angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/projects/viewProjectsOld.html',
    '<section class="content dashboard public">\n' +
    '    <div class="container">\n' +
    '        <h2>Projects</h2>\n' +
    '        <div id="cards" class="d-flex flex-row" lazy-scroll="getMoreProjects()" lazy-scroll-trigger="80">\n' +
    '            <div class="card" ng-repeat="project in projects track by $index">\n' +
    '                <div class="project-closed" ng-if="project.Status == \'closed\' || project.Status == \'hired\'"></div>\n' +
    '                <div class="map">\n' +
    '                    <ng-map disable-default-u-i="project.Status == \'closed\' || project.Status == \'hired\'" zoom="12" class="h-100" default-style="false"\n' +
    '                        center="{{project.latlng }}" pan-control="false" map-type-control="false" zoom-control="false">\n' +
    '                        <marker position="{{project.latlng}}" icon="{\n' +
    '                            url:\'assets/img/marker.png\'\n' +
    '                          }"></marker>\n' +
    '                        <!--<shape id="circle" name="circle" stroke-color=\'#0784b3\' stroke-opacity="0.8" stroke-weight="2" fill-color=\'#0784b3\' center="{{project.latlng}}"\n' +
    '                            radius="{{distance}}"></shape>-->\n' +
    '                    </ng-map>\n' +
    '                </div>\n' +
    '                <section class="project-engineer">\n' +
    '                    <a target="_blank" ng-if="project.Attachment" ng-href={{project.Attachment.Url}} class="project-doc fa fa-file-pdf-o download-pdf"\n' +
    '                        uib-tooltip="Download PDF">\n' +
    '                    </a>\n' +
    '                    <h4>\n' +
    '                        <a href="" ui-sref="project({uid:project.UID})">{{::project.LicenseLabel}}</a>\n' +
    '                        <small>{{::project.City}}, {{::project.StateLicense}}</small>\n' +
    '                    </h4>\n' +
    '                    <h5>\n' +
    '                        {{::project.Title}}\n' +
    '                    </h5>\n' +
    '                    <p class="project-teaser">\n' +
    '                        {{::project.Description | trimText:true:100:\' ...\'}}\n' +
    '                    </p>\n' +
    '                    <p class="project-date">\n' +
    '                        <span class="text-muted">Proposal Deadline</span>{{::project.ClosingDate | localeDateHuman}}\n' +
    '                    </p>\n' +
    '                    <a ng-if="project.Status != \'closed\' && project.Status != \'hired\'" href="" ui-sref="project({uid:project.UID})" class="btn btn-primary mt20">View</a>\n' +
    '                </section>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <!-- Load more -->\n' +
    '    <div class="load-cards" ng-show="loading">\n' +
    '        <a href="javascript:;" class="fa fa-refresh fa-spin"></a>\n' +
    '    </div>\n' +
    '</section>');
}]);
